<div>
  <ng-container *ngFor="let item of WidgetList; let lastItem = last; trackBy: trackByWidgetId">
    <!-- Dynamic component rendering using NgComponentOutlet with inputs -->
    <div *ngIf="item?.show && item?.ready && !hiddenWidgetIds?.includes(item?.widgetId)">
      <div class="widget-container">
        <!-- Render widget using Angular's built-in NgComponentOutlet with injector -->
        <ng-container *ngIf="widget[item?.widgetName]; else fallbackWidget">
          <ng-template
            [ngComponentOutlet]="widget[item?.widgetName]"
            [ngComponentOutletInjector]="item?.widgetInjector">
          </ng-template>
        </ng-container>

        <!-- Fallback template if widget not found -->
        <ng-template #fallbackWidget>
          <div class="widget-fallback" *ngIf="item?.hasError"
               style="border: 1px solid #dc3545; padding: 8px; margin: 4px; background: #f8d7da; color: #721c24;">
            <strong>{{ item?.widgetName }}</strong>
            <br>
            <small>Widget temporarily unavailable due to injection error</small>
          </div>

          <!-- Show debug info for unmapped widgets -->
          <div class="widget-debug" *ngIf="!widget[item?.widgetName] && !item?.hasError"
               style="border: 1px solid #fd7e14; padding: 8px; margin: 4px; background: #fff3cd; color: #856404;">
            <strong>Widget Mapping Missing:</strong> {{ item?.widgetName }}
            <br>
            <small>This widget needs to be added to the component mapping</small>
          </div>
        </ng-template>
      </div>
    </div>
    <div *ngIf="lastItem" intersectionObserver (visibilityChange)="onVisibilityChanged(item?.widgetType, $event)"></div>
  </ng-container>
</div>

<ng-container *ngFor="let item of 5 | times; let i = index">
  <app-common-skeleton *ngIf="loadAPIcall" [NameOftheScreen]="'widgets'"></app-common-skeleton>
</ng-container>
